import {Check, GitPullRequest, MessageSquare, ArrowDown} from 'lucide-react';

// An illustrative workflow, not a screenshot or a claim about a customer result.
export default function DecisionTrailPreview({label}) {
  return <figure className="decision-trail-preview" role="img" aria-label={label}>
    <div className="decision-trail-preview-header">
      <strong>Decisions</strong><span>Example trail</span>
    </div>
    <ol>
      <li>
        <Check size={18} aria-hidden="true"/>
        <div><span>Your decision</span><strong>Simplify setup before adding a dashboard.</strong><p>Help people finish their first project.</p></div>
      </li>
      <li>
        <GitPullRequest size={18} aria-hidden="true"/>
        <div><span>Linked work</span><strong>Shorter setup built and checked.</strong><p>Changes and test results returned to the decision.</p></div>
      </li>
      <li>
        <MessageSquare size={18} aria-hidden="true"/>
        <div><span>Outcome still to check</span><strong>Are more people finishing?</strong><p>Bring customer evidence back to guide the next move.</p></div>
      </li>
    </ol>
    <figcaption><ArrowDown size={14} aria-hidden="true"/> Keep the goal in view through the work.</figcaption>
  </figure>;
}
